import { focusFirstAvailableSeat, focusSelectedSeat } from '../../utils/focusUtils';
export const getTravelerButtonProps = ({
  activeTraveler,
  onChange,
  selectedSeat,
  setTravelerButtonWithRemoveLink,
  travelerId
}) => {
  const isActive = travelerId === activeTraveler;
  const handleClick = () => {
    onChange === null || onChange === void 0 || onChange(travelerId);
    setTravelerButtonWithRemoveLink(selectedSeat ? travelerId : undefined);
    if (selectedSeat) {
      focusSelectedSeat(selectedSeat.row, selectedSeat.value);
    } else {
      focusFirstAvailableSeat();
    }
  };
  const handleFocus = () => setTravelerButtonWithRemoveLink(travelerId);
  return {
    handleClick,
    handleFocus,
    isActive
  };
};
//# sourceMappingURL=travelerButtonUtils.js.map